import api, { withLoading } from '@/api/api';

const resource = `v1/ict/relatorio`;
const LOADING_KEY = 'ict-relatorio';

export default {
    getDespesas(empresaId, projetoId) {
        return withLoading(LOADING_KEY, () =>
            api.get(`${resource}/${empresaId}/${projetoId}/despesas`).then(res => res.data)
        );
    }
};
